import Vue from 'vue'

export default Vue.component('preview-img-formatter', {
  functional: true,
  props: {
    formatter: Function,
    imgConfig: Object,
    currentIndex: Number,
    loadImgSrc: String
  },
  render (h, self) {
    let formatter = self.props.formatter || self.props.option.formatter
    return formatter(h, {
      imgConfig: self.props.imgConfig,
      currentIndex: self.props.currentIndex,
      loadImgSrc: self.props.loadImgSrc,
    })
  }
})



// WEBPACK FOOTER //
// ./src/public/components/kye-preview/component/preview-wrapper/formatter.js